import Box from '@mui/material/Box/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography/Typography';

import styled from 'styled-components';
import { colors, devices } from 'styles';
import CaretIcon from 'assets/resources/caret-right.svg';

export const TermsAndConditionsWrapper = styled(Typography)`
  font-size: 12px;
  line-height: 150%;
  margin: 16px 0 !important;
  color: #000000;
  text-align: left;
`;

export const LeftMenuWrapper = styled(Box)`
  width: 273px;
  position: sticky;
  top: 100px;
  align-self: flex-start;
  height: fit-content;

  @media (${devices.sm}) {
    width: 260px;
  }
`;

export const LeftMenuTop = styled(Box)`
  display: none;

  @media (${devices.md}) {
    display: block;
  }
`;

export const SubPageSubscribeButton = styled(Button)`
  width: 100%;
  margin-top: 16px !important;
  background: black !important;
  font-size: 16px !important;
  line-height: 24px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  padding: 16px 0 !important;

  &:hover {
    background: black !important;
    opacity: 0.8;
  }
`;

export const WaypointsButton = styled('button')<{ isOpen: boolean }>`
  display: block;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid ${colors.mainGray};
  background-color: ${colors.brandLightGrey};
  background-image: url(${CaretIcon});
  background-size: 32px;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 90px;
  left: 16px;
  z-index: 10000;
  ${({ isOpen }) => isOpen && 'transform: rotate(180deg);'}
  transition: transform ease 0.25s;
  transition: left ease 0.3s;

  @media (${devices.sm}) {
    top: 75px;
    ${({ isOpen }) => isOpen && 'left: 292px;'}
  }

  @media (${devices.md}) {
    display: none;
  }
`;
